//region :: Imports ::
import {evalulateBool, MBoolean} from '../../Toolkit/Components/Controls/Control';
import MComponent from '../../Toolkit/Components/Component';
import {DropdownChangeParams} from 'primereact/dropdown';
import {ReactElement} from 'react';
import MDropDownOption, {MDropDownItem} from '../../Toolkit/Components/Controls/DropDownOption';
import {setFieldValue} from '../../Toolkit/Utils';
import {FieldProps} from 'formik';
import {MultiSelect} from 'primereact/multiselect';

//endregion

/** */
type Props<TValue> = {
    id: string;
    initialValue?: TValue[];
    items: MDropDownItem<TValue>[];
    placeholderText?: string;
    showFilter?: boolean;
    isBusy?: MBoolean;
    fieldProps?: FieldProps;
    disabled: MBoolean;
    className?: string;
    onChange?: (newValue: TValue[]) => void;
    maxSelectedLabels?: number;
}

/** */
type State<TValue> = {
    value: TValue[];
}

/** */
class MDropDownMulti<TValue> extends MComponent<Props<TValue>, State<TValue>> {

    /** */
    public constructor(props: Props<TValue>) {
        super(props);

        this.bindMethods();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {

        this.dropDown_OnChange = this.dropDown_OnChange.bind(this);

    }

    /** */
    private initializeState(): void {

        this.state = {value: this.props.initialValue === undefined ? [] : this.props.initialValue};
        setFieldValue(this.props.fieldProps, this.state.value);

    }

    /** */
    private dropDown_OnChange(params: DropdownChangeParams): void {
        this.setValue(params.value);
    }

    /** */
    public static getOptionTemplate<TValue>(item: MDropDownItem<TValue>): ReactElement<MDropDownOption<TValue>> {

        return (
            <MDropDownOption label={item.label}
                             value={item.value}
                             badge={item.badge}
                             badgeSeverity={item.badgeSeverity}/>
        );

    }

    /** */
    public setValue(newValue: TValue[]): void {

        this.safeSetState((draft: State<TValue>) => draft.value = newValue);
        setFieldValue(this.props.fieldProps, newValue);
        this.props.onChange?.(newValue);

    }

    /** */
    public componentDidUpdate(prevProps: Readonly<Props<TValue>>, prevState: Readonly<State<TValue>>, snapshot?: any): void {

        if(this.props.fieldProps?.field.value !== prevProps.fieldProps?.field.value) {

            this.safeSetState((draft: State<TValue>) =>
                draft.value = this.props.fieldProps!.field.value);

        }

    }

    /** */
    public render(): ReactElement {

        return (
            <MultiSelect id={this.props.id}
                         optionLabel="label"
                         optionValue="value"
                         options={this.props.items}
                         filter={this.props.showFilter}
                         placeholder={this.props.placeholderText}
                         itemTemplate={MDropDownMulti.getOptionTemplate}
                         disabled={evalulateBool(this.props.disabled)}
                         className={this.props.className}
                         {
                            ...this.props.fieldProps?.field
                         }
                         value={this.state.value}
                         onChange={this.dropDown_OnChange}
                         maxSelectedLabels={this.props.maxSelectedLabels}

            />
        );

    }

}

export default MDropDownMulti;
